import { SNoop } from '@obvious.tech/util/validation/schemas'
import { defineEntity } from '../../defineEntity'
import { ISipCallLog } from '@obvious.tech/constellation'

export const SipCallLog = defineEntity('SipCallLog', {
  endpoint: 'sip/api/SipCallLog',
  schema: SNoop<ISipCallLog>(),
})
